module.exports = __webpack_public_path__ + "img/syshy.2eaeb974.png";